var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding"},[_c('b-modal',{ref:"edit-form",attrs:{"hide-footer":"","size":"lg"}},[_c('HistoryEditor',{attrs:{"history":_vm.history}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }